/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "CreateJobRequest": {
            "fields": {
              "job": {
                "type": ".squareup.team_api.Job",
                "id": 1,
                "rule": "optional"
              },
              "idempotencyKey": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "CreateJobResponse": {
            "fields": {
              "job": {
                "type": ".squareup.team_api.Job",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.CreateJobRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.CreateJobResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a [CreateJob](api-endpoint:Team-CreateJob) request.
 * --
 *
 * SOURCE CreateJobRequest @ squareup/team_api/endpoints/create-job.proto at 23:1
 */
export const CreateJobRequest = $root.lookupType('squareup.team_api.CreateJobRequest');
fixType(CreateJobRequest, {
  job: {
    required: true
  },
  idempotencyKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateJobRequest);
/**
 * --
 * @desc Represents a [CreateJob](api-endpoint:Team-CreateJob) response. Either `job` or `errors`
 * is present in the response.
 * --
 *
 * SOURCE CreateJobResponse @ squareup/team_api/endpoints/create-job.proto at 47:1
 */
export const CreateJobResponse = $root.lookupType('squareup.team_api.CreateJobResponse');
fixType(CreateJobResponse);
Builder.createAndAttachToType(CreateJobResponse);